import {Weiwudi_Internal} from "./weiwudi_gw_logic";

Weiwudi_Internal(self.workbox.routing.registerRoute);